// extracted by mini-css-extract-plugin
export default {"Container":"SimpleMainNav_Container__LxspS","Logo":"SimpleMainNav_Logo__lwo2j"};